<div class="bg_clr">
  <div class="login_box">
    <div class="login_box_content">
      <div class="login-wrapper-bg">
        <div class="login-wrapper-bg">
          <div class="logo">
            <div class="logo-img">
              <img src="../../../assets/images/login-logo.svg" class="img-responsive" alt="WOW" />
              <p>Ways of Working</p>
            </div>
          </div>
        <div class="login_content">
          <div class="login_form">
            <form action="" (submit)="forgotPassword()" novalidate='' #forgotPwd="ngForm">
              <div class="form-group">
                <mat-form-field class="example-full-width login-input">
                  <input matInput type="text" name="username" [(ngModel)]="userid" #emailId="ngModel" placeholder="UserID" minlength="3" maxlength="25"
                    required />
                  <mat-error *ngIf="emailId.errors &&  emailId.touched">
                    <mat-hint [hidden]="!emailId.errors.required">UserID is required</mat-hint>
                    <mat-hint [hidden]="!emailId.errors.minlength">UserID must be 3 characters</mat-hint>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-actions">
                <button type="submit" class="save" [disabled]="!forgotPwd.valid">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>